import { Component, OnInit, ContentChildren, Input, Output, EventEmitter } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { tap } from 'rxjs/operators';
import { AngularFireStorage, AngularFireUploadTask } from 'angularfire2/storage';
import { Observable } from 'rxjs/Observable';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss']
})
export class FileUpload {
    // @Output() toggleEditEvent: EventEmitter<boolean> = new EventEmitter();
    @Input('uploadPath') uploadPath: string;
    @Input('metadata') metadata: {};
    @Input('fileType') fileType: string;
    @Input('fileSizeLimit') fileSizeLimit: number;
    // @Input('resetUploadTrigger') resetUpload: boolean = false;

    @Output() isUploading: EventEmitter<boolean> = new EventEmitter();
    @Output() url: EventEmitter<string> = new EventEmitter();

    // Main task
    task: AngularFireUploadTask;

    // Progress monitoring
    percentage: Observable<number>;
    uploadDone: boolean = false;

    snapshot: Observable<any>;

    // Download URL
    downloadURL: Observable<string>;

    // State for dropzone CSS toggling
    isHovering: boolean;

    constructor(private storage: AngularFireStorage, private toastr: ToastrService, private db: AngularFirestore) { }


    toggleHover(event: boolean) {
        this.isHovering = event;
    }


    startUpload(event: FileList) {
        this.isUploading.emit(true);
        this.toastr.clear();
        // The File object
        const file = event.item(0);

        // Client-side validation example
        if (file.type.split('/')[0] !== this.fileType.toLowerCase()) {
            console.error('unsupported file type :( ');
            return;
        }

        let sizeInMB = (file.size / 1024) / 1024;
        console.debug('file size in MB: ', sizeInMB);
        if (sizeInMB > this.fileSizeLimit) {
            console.error('file size is too big :( ');
            this.toastr.error(
                'Please upload files that are less than ' + this.fileSizeLimit + ' Megabytes.',
                'File Size Is Too Big', { timeOut: 10000 });
            return;
        }

        // The storage path
        const path = this.uploadPath + `/${new Date().getTime()}_${file.name}`;

        // Totally optional metadata
        // const customMetadata = { app: 'My AngularFire-powered PWA!' };
        const customMetadata = this.metadata;

        // The main task
        this.task = this.storage.upload(path, file, { customMetadata });

        // Progress monitoring
        this.percentage = this.task.percentageChanges();
        this.snapshot = this.task.snapshotChanges();

        // The file's download URL
        this.downloadURL = this.task.downloadURL();
        console.info(this.downloadURL);
        this.downloadURL.subscribe(val => {
            console.debug('Got Value from Subscription... ', val);
            this.url.emit(val);
            this.isUploading.emit(false);
            this.uploadDone = true;
            this.toastr.success('File Uploaded Successfully', 'Success', { timeOut: 8000 });

        }, error => {
            this.toastr.error(error.message, 'Error', { timeOut: 10000 });
            console.error(error);
            this.isUploading.emit(false);
            this.uploadDone = true;
        });
    }

    // Determines if the upload task is active
    isActive(snapshot) {
        return snapshot.state === 'running' && snapshot.bytesTransferred < snapshot.totalBytes
    }

}


// WEBPACK FOOTER //
// ./src/app/theme/layouts/file-upload/file-upload.component.ts